<template>
    <v-container align-center justify-center style="min-height:600px; padding-top:120px;">
        <v-row>
          <v-col cols="12" sm="10" offset-sm="1" md="4" offset-md="4">
            <img src = 'img/logo_tiba.png' width="250" style="display:block; margin:auto;"/>
          </v-col>
        </v-row> 
          <v-row>
            <v-col cols="12" sm="10" offset-sm="1" md="4" offset-md="4" style="padding: 12px 0;">
              <v-card>
                <v-card-text class="pt-4">
                  <div>
                      <v-form v-model="valid" ref="form">
                        <v-text-field
                          class="mt-3"
                          outlined
                          :placeholder="$t('login.username')"
                          v-model="email"
                          required
                        ></v-text-field>
                        <v-text-field
                          outlined
                          :placeholder="$t('login.password')"
                          v-model="password"
                          min="8"
                          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                          @click:append="() => (showPassword = !showPassword)"
                          :type="showPassword ? 'password' : 'text'"
                          counter
                          required
                        ></v-text-field>
                        <v-layout justify-space-between>
                            <v-btn class="flexiapp-vbtn primary" @click="submit" 
                                :class=" { 'blue darken-4 white--text' : valid, disabled: !valid }"
                                :loading="isLoading"
                                :disabled="isLoading"
                            >{{this.$t('login.submit')}}</v-btn>
                        </v-layout>
                        <v-checkbox v-model="recallCredentials" :disabled="isLoading" :label="$t('login.remember.credentials')"/>                        
                      </v-form>
                  </div>
                </v-card-text>
              </v-card>
              <v-row v-if="!isLoading && accessError" justify="center" class="mt-4">
                <v-alert type="error" justify="center">{{
                    accessErrorMessage
                }}</v-alert>
              </v-row>
            </v-col>
            </v-row>
            <v-row style="position:fixed; bottom:0px; right:20px">
                <span class="caption grey--text lighten-5" show-version> {{version}}</span>
            </v-row>
          </v-container>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import api from "../../../api/flexiapp"; 
import discovery from "../../../discovery";

export default {
  name: "LoginMain", 
  components: { },
  data() {
      return {
            valid: false,
            isLoading: false,
            accessErrorMessage:null,
            accessError:false,
            showPassword: true,
            version: 'x.x.x',
            password: '',
            passwordRules: [
              (v) => !!v || 'Password is required',
            ],
            email: '',
            recallCredentials: false,
          }
  },
  methods: {
    checkLoginInfo: function(info) {
        this.$log.debug("checkLoginInfo() called! [ info: " + info + " ]");

        this.recallCredentials = true;

        this.email = info.split("@")[0];
        this.password = info.split("@")[1];
    },  

      submit: function() {
          this.isLoading=true;
          var data ={
              Login : this.email,
              Password : this.password,
          }
          api.getSessionToken(
              data,
          (data) => {
              this.isLoading=false;
              this.$store.commit('flexiapp/setToken', data);
              window.localStorage.setItem("vue-token", data);

            if (this.recallCredentials) {
                window.localStorage.setItem("flexiapp-login-info", btoa(this.email + "@" + this.password));
            } else {
                window.localStorage.removeItem("flexiapp-login-info");
            }
              this.getUserInformacion();                           
          },
          (error) => {
            this.isLoading=false;
            this.accessErrorMessage=error.response.data.Message ? error.response.data.Message : error ;
            this.accessError=true;
          });           
      },      
     getUserInformacion(){
           this.isLoading=true;
           api.getUserInfo(
                (data2) => {
                    this.isLoading=false;
                    this.$store.commit('flexiapp/setUser', data2);
                    this.$router.push({ name: 'home'})
                 },
                (error) => {
                    this.isLoading=false;
                    this.accessErrorMessage=error.response.data ? error.response.data : error ;
                    this.accessError=true;
                });
      }
  },
  beforeRouteEnter (to, from, next) {
      next(vm => {
        vm.email = null;
        vm.password = null;
        vm.$store.commit('flexiapp/setUser', {});
        vm.$store.commit('flexiapp/setToken', null);
        vm.recallCredentials = false;
        vm.version = discovery.version;

        var info = window.localStorage.getItem("flexiapp-login-info");

        if (!info) {
            vm.$log.debug("Login info not found!");
            return;
        }

        vm.recallCredentials = true;
        
        vm.checkLoginInfo(atob(info));       
      })
    }
}
</script>

<style>
@media screen and ( max-height: 520px )
{
   .show-version{
        display: none;
    }
}

@media screen and ( min-height: 521px )
{
   .show-version{
        display: block;  
    }
}

</style>